<template>
    <div>
        <b-img :src="require('../../assets/9.jpg')" fluid alt="Responsive image" />
        <b-container>
            <h2 class="mt-4">SUPERSTAR DJ, HERE WE GO!</h2>
            <p>Make sure you keep an eye on your phone or you will miss your chance!</p>
            <p>Here are your set details!</p>
            <p v-if="booking.setTime">Set Time: <strong>{{$moment(booking.setTime).format('HH:mm')}}</strong></p>
            <p>DJ Name: <strong>{{booking.djName}}</strong></p>
            <p><strong>Tracks</strong></p>
            <b-table bordered responsive hover :items="this.tracks" thead-class="d-none"></b-table>
            <b-row class="mt-2 mb-3">
                <b-col>
                    <b-button to="/share" variant="default" block>Share My Set</b-button>
                </b-col>
                <b-col>
                    <b-button to="/choon" block variant="default">CHOON!</b-button>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import { EventBus } from "../../EventBus";
    import _ from 'lodash';
    export default {
        name: "BookingDetails",
        methods: {
            getActiveSet() {
                EventBus.$emit('loading-show');
                this.$axios.get(`booking/email/${this.$store.state.user.email}`).then(result => {
                    EventBus.$emit('loading-hide');
                    if (result.data) {
                        this.booking = result.data;
                        _.forEach(this.booking.tracks, (track) => {
                            this.tracks.push(processTrackToOneLine(track));
                        });
                    } else {
                        EventBus.$emit('message', {message: `You don't have an active set!`, type: 'danger'});
                        this.$router.replace('/landing');
                    }
                }).catch(() => {
                    EventBus.$emit('loading-hide');
                    EventBus.$emit('message', {message: 'Oops this isn’t working, don’t worry please show your host to resolve it', type: 'danger'});
                });
            }
        },
        data() {
            return {
                booking: {},
                tracks: []
            }
        },
        mounted() {
            this.getActiveSet();
        }
    }
    function processTrackToOneLine(obj) {
        return {track: `${obj.artist} - ${obj.track}`};
    }
</script>

<style scoped>

</style>
